<div class="layout">
    <h1>{{'page-not-found' | translate}}</h1>
    <span class="material-symbols-outlined">
        sentiment_sad
    </span>
</div>